import { Component } from "react";
import { isNotEmpty, handleFormikValueChange, isNothing } from "../../utils";
import InputAlert from "./InputAlert";
import { AlertType } from "../../constants";

type Props = {
  id: string;
  name?: string;
  status?: string;
  isSubmitting?: boolean;
  errors?: $TSFixMe;
  values?: $TSFixMe;
  options?: {
    value?: string;
    label?: string;
    contextualHelp?: React.ReactElement;
  }[];
};

class RadioSelect extends Component<Props> {
  constructor() {
    // @ts-expect-error TS(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    /* istanbul ignore next */
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(event: $TSFixMe) {
    const { value } = event.target;
    handleFormikValueChange(this.props, value);
  }

  render() {
    const { id, name, isSubmitting, values, errors, status, options } =
      this.props;

    const error =
      status === "submitted" &&
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      isNotEmpty(errors[name]) &&
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      isNothing(values[name]);
    const className = error ? "form-group has-error" : "form-group";
    // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    const errorMessage = error ? errors[name] : null;

    return (
      <div className={className}>
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        {options.map((option) => (
          <div className="radio" key={option.value}>
            <input
              id={`${id}-${option.value}`}
              disabled={isSubmitting}
              type="radio"
              name={id}
              onChange={this.handleOnChange}
              value={option.value}
              // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
              checked={values[name] === option.value}
            />
            <label htmlFor={`${id}-${option.value}`}>{option.label}</label>
            {option.contextualHelp || null}
          </div>
        ))}
        <InputAlert message={errorMessage} type={AlertType.ERROR} />
      </div>
    );
  }
}

export default RadioSelect;
